var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.menuItemCode != "JGW-1-4"
        ? [_c("warn_record_detail", { attrs: { propId: _vm.id } })]
        : [_c("warn_record_activity_detail", { attrs: { propId: _vm.id } })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }